import { FormFieldTypes } from "../../../data/formFieldType";

const LoginFormData = {
    name: "Login From",
    //initialState: { userName: "kirtan@gmail.com", password: "Moltech@1234" },
    initialState: { userName: "", password: "" },
    formFields: [
        {
            id: "userName",
            lable: "User Name",
            Field_Name: "username",
            fieldType: FormFieldTypes.INPUT,
            dataField: "userName",
            fieldSetting: {
                placeholder: "User Name",
                allowSpace: true,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-md-12"
            }
        },
        {
            id: "Password",
            lable: "Password",
            Field_Name: "password",
            fieldType: FormFieldTypes.PASSWORD,
            dataField: "password",
            fieldSetting: {
                placeholder: "Password",
            },
            style: {
                containerCss: "col-md-12"
            },
            validation: [{ type: "require"},{ type: "password"}]
        },
    ],
};

export default LoginFormData;